import React, { useEffect, useState } from 'react';
import VideoCard from '../Components/VideoCard'
import { useLocation } from 'react-router-dom';
import Sidebar from '../Components/Sidebar';
import Header from '../Components/Header';
import BackButton from '../Components/BackButton';
import GlobalAlert from '../Components/GlobalAlert'
import { BookHeart } from 'lucide-react';


export default function Category() {

  const location = useLocation();
  const { category } = location.state || {}; // Handle undefined state


  const [data, setData] = useState([]);
  const [favorites, setFavorites] = useState([]);


  useEffect(() => {
    const sessiondata = JSON.parse(localStorage.getItem('av_favorites'))

    if (sessiondata) {
        setFavorites(sessiondata)
    }


  }, []);


  
    function fecthData() {
      fetch('https://apiv2.mobileartsme.com/av_getcontent?apisource=1&phonenumber=96170932819&ispremium=true&language=en&country=LB')
        .then(response => response.json())
        .then(data => {
          setData(data.Content[0].Videos)
          sessionStorage.setItem('av_data', JSON.stringify(data.Content[0].Videos))
          console.log(data.Content[0].Videos)
        }
        );
    }
  
    useEffect(() => {
      const sessiondata = JSON.parse(sessionStorage.getItem('av_data'))
      if (sessiondata) {
        setData(sessiondata)
      } else {
        fecthData()
      }
    }, []);

  return (
    <div>

      <Sidebar data={data} />
      <GlobalAlert/>
      <div className='main-body' >
        <div className='container' >
          <BackButton />
          <h2 className='my-4 spangreen' >Favorites</h2>

          {favorites.length!=0 ? 
          <div className='videos-container' >
            
            {favorites.map((video, index) => (
              <VideoCard key={index} video={video} category={null}  /> // Pass 'video' correctly
            ))
            }

          </div>
        :
        <div className='d-flex flex-column align-items-center justify-content-center w-100 text-center'>
        <BookHeart size={100} />
        <h4 className='mt-3'>No Favorites Yet</h4>
        <p>Explore our collection and add videos to your favorites for quick access anytime.</p>
      </div>
      
}
        </div>

      </div>


    </div>
  )
}
